import Splide from "@splidejs/splide";
import { AutoScroll } from "@splidejs/splide-extension-auto-scroll";
import "@splidejs/splide/css/core";

export const partnerSlider = () => ({
  init() {
    new Splide(this.$refs.splide, {
      type: "loop",
      drag: "free",
      focus: "center",
      autoWidth: true,
      autoScroll: {
        speed: 1,
        pauseOnHover: true,
        pauseOnFocus: false,
      },
      arrows: false,
      pagination: false,
      gap: "2.5rem",
      breakpoints: {
        768: {
          gap: "2rem",
        },
        640: {
          gap: "1.5rem",
        },
      },
    }).mount({ AutoScroll });
  },
});
